<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical :headerTitle="`${pageTitle}`" device="web">
        <template v-slot:body>
          <v-sheet class="tab-layout">
            <!-- 좌측 tab -->
            <v-card color="inner_card_bg" class="overflow-y-auto">
              <v-list class="pa-0 contents-menu">
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, index) in tabList"
                    :key="item.index"
                    @click="handleTabClick(index)"
                    :class="{ active: selectedKey === index }"
                  >
                    <v-list-item-content>{{ item.minorNm }}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
            <!-- 우측 테이블 영역 -->
            <v-card :class="breakpoint === 'md' || breakpoint === 'sm' || breakpoint === 'xs' ? 'mt-5' : ''">
              <span class="editor-title">{{ tabList[selectedKey] ? tabList[selectedKey].minorNm : '' }}</span>
              <p>작성된 절차서는 관련 화면에서 확인할 수 있습니다.</p>
              <v-form ref="form">
                <v-row no-gutters>
                  <!-- 해당 selectedKey 순번은 시스템코드 순번과 동일하게 매핑하여야 정상동작 합니다. -->
                  <!-- 경영자 리더십 절차 -->
                  <v-col v-if="selectedKey == 0">
                    <LeaderShipProcedure ref="LeaderShip" />
                  </v-col>
                  <!-- 예산 편성 절차 -->
                  <v-col v-else-if="selectedKey == 1">
                    <ShBudgetProcedure ref="ShBudget" />
                  </v-col>
                  <!-- 근로자 참여 절차 -->
                  <v-col v-else-if="selectedKey == 2">
                    <WorkerParticipationProcedure ref="WorkerParticipation" />
                  </v-col>
                  <!-- 위험성평가 절차-->
                  <v-col v-else-if="selectedKey == 3">
                    <RiskAssessmentProcedure ref="RiskAssessment" />
                  </v-col>
                  <!-- 안전보건 교육 절차 -->
                  <v-col v-else-if="selectedKey == 4">
                    <EducationProcedure ref="Education" />
                  </v-col>
                  <!-- 비상대응계획 절차 -->
                  <v-col v-else-if="selectedKey == 5">
                    <EmergencyActionPlanProcedure ref="EmergencyActionPlan" />
                  </v-col>
                  <!-- 재발방지대책 절차 -->
                  <v-col v-else-if="selectedKey == 6">
                    <PreventRecurrenceProcedure ref="PreventRecurrence" />
                  </v-col>
                  <!-- 도급용역 위탁 안전보건 확보 절차 -->
                  <v-col v-else-if="selectedKey == 7">
                    <ContractServiceConsignmentProcedure ref="ContractServiceConsignment" />
                  </v-col>
                  <!-- 성과평과 절차 -->
                  <v-col v-else-if="selectedKey == 8">
                    <PerformanceEvaluationProcedure ref="PerformanceEvaluation" />
                  </v-col>
                  <v-col v-else-if="selectedKey == 9">
                    <AuthGroupProcedure ref="AuthGroup" />
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-sheet>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          headerTitle
          :useBtnList="buttonUseList"
          @btnSample="btnSample(true)"
          @btnSearch="btnSearch(true)"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
          @btnPrint="btnPrint"
        ></i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
// Components
import baseview from '@/views/base/baseview.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iCardRight from '@/components/common/iCardRight.vue'
import { getCommonCode } from '@/api/common/commonApi'
import {
  getLeaderShipProcedure,
  getLeaderShipProcedureSample,
  getLeaderShipProcedureReport,
  saveLeaderShipProcedure,
  deleteLeaderShipProcedure
} from '@/api/procedure/leaderShipProcedure.js'

import LeaderShipProcedure from '@/views/procedure/components/LeaderShipProcedure.vue'
import RiskAssessmentProcedure from '@/views/procedure/components/RiskAssessmentProcedure.vue'
import ShBudgetProcedure from '@/views/procedure/components/ShBudgetProcedure.vue'
import AuthGroupProcedure from '@/views/procedure/components/AuthGroupProcedure.vue'
import EmergencyActionPlanProcedure from '@/views/procedure/components/EmergencyActionPlanProcedure.vue'
import ContractServiceConsignmentProcedure from '@/views/procedure/components/ContractServiceConsignmentProcedure.vue'
import PerformanceEvaluationProcedure from '@/views/procedure/components/PerformanceEvaluationProcedure.vue'
import WorkerParticipationProcedure from '@/views/procedure/components/WorkerParticipationProcedure.vue'
import EducationProcedure from '@/views/procedure/components/EducationProcedure.vue'
import PreventRecurrenceProcedure from '@/views/procedure/components/PreventRecurrenceProcedure.vue'

export default {
  mixins: [baseview, iCardRight],
  components: {
    'i-card-vertical': iCardVertical,
    LeaderShipProcedure,
    RiskAssessmentProcedure,
    ShBudgetProcedure,
    AuthGroupProcedure,
    EmergencyActionPlanProcedure,
    ContractServiceConsignmentProcedure,
    PerformanceEvaluationProcedure,
    WorkerParticipationProcedure,
    EducationProcedure,
    PreventRecurrenceProcedure
  },
  data() {
    return {
      pageTitle: '절차서 관리',
      initCompId: '',
      rules: [value => !!value || '필수 입력값입니다.'],
      buttonUseList: [
        'btnSample', // 예시보기
        'btnSearch', // 조회
        'btnSave', // 저장
        'btnDelete', // 삭제
        'btnPrint' // 출력
      ],
      procedure: {
        clntId: '',
        content: ''
      },
      tabList: [],
      selectedKey: 0
    }
  },
  computed: {
    mobileTrigger: function() {
      return this.width < 800
    }
  },
  created() {
    this.initCompId = this.getCompId()
    this.btnSearch(true)
  },
  beforeMount() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
    Promise.all([getCommonCode('PRO001')]).then(response => {
      this.tabList = response[0].list
    })
  },
  mounted() {},
  activated() {
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch(true)
    }
  },
  methods: {
    breakpoint() {
      return this.$vuetify.breakpoint.name
    },
    async handleTabClick(index) {
      if (this.selectedKey !== index) {
        this.selectedKey = index
      }
    },
    //////////////////////////////////////////////////////////////////////
    // 버튼 이벤트
    //////////////////////////////////////////////////////////////////////
    async btnSample(isNotify) {
      let name = this.tabList[this.selectedKey].extra1
      await this.$refs[name].btnSample(isNotify)
    },
    async btnSearch(isNotify) {
      if (this.tabList[this.selectedKey]) {
        let name = this.tabList[this.selectedKey].extra1
        await this.$refs[name].btnSearch(isNotify)
      }
    },
    btnSave() {
      const validate = this.$refs.form.validate()
      if (!validate) {
        this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'info')
        return
      }
      let name = this.tabList[this.selectedKey].extra1
      this.$refs[name].btnSave()
    },
    btnDelete() {
      let name = this.tabList[this.selectedKey].extra1
      this.$refs[name].btnDelete()
    },
    async btnPrint(type) {
      let name = this.tabList[this.selectedKey].extra1
      this.$refs[name].btnPrint(type)
    }
  }
}
</script>

<style scoped lang="scss">
.tab-layout .v-card.inner_card_bg:has(.contents-menu) {
  width: 300px;
}
.tab-layout .v-card.inner_card_bg:has(.contents-menu) + div {
  width: calc(100% - 324px);
}

@media (max-width: 1024px) {
  .tab-layout .v-card.inner_card_bg:has(.contents-menu) {
    width: 100%;
  }
  .tab-layout .v-card.inner_card_bg:has(.contents-menu) + div {
    width: 100%;
    margin-top: 24px;
  }
}
</style>
